import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CatalogState, featureKey, State } from './combiner';

export const selectCatalogState = createFeatureSelector<State, CatalogState>(featureKey);

export const selectRoadTypesState = createSelector(selectCatalogState, (state: CatalogState) => state.roadTypes);
export const selectRoadTypeState = createSelector(selectCatalogState, (state: CatalogState) => state.roadType);
export const selectTownsState = createSelector(selectCatalogState, (state: CatalogState) => state.towns);
export const selectTownState = createSelector(selectCatalogState, (state: CatalogState) => state.town);
export const selectGendersState = createSelector(selectCatalogState, (state: CatalogState) => state.genders);
export const selectGenderState = createSelector(selectCatalogState, (state: CatalogState) => state.gender);
export const selectHomeTypesState = createSelector(selectCatalogState, (state: CatalogState) => state.homeTypes);
export const selectHomeTypeState = createSelector(selectCatalogState, (state: CatalogState) => state.homeType);
export const selectFloorNumbersState = createSelector(selectCatalogState, (state: CatalogState) => state.floorNumbers);
export const selectFloorNumberState = createSelector(selectCatalogState, (state: CatalogState) => state.floorNumber);
export const selectAlarmTypesState = createSelector(selectCatalogState, (state: CatalogState) => state.alarmTypes);
export const selectAlarmTypeState = createSelector(selectCatalogState, (state: CatalogState) => state.alarmType);
export const selectHomeRegimesState = createSelector(selectCatalogState, (state: CatalogState) => state.homeRegimes);
export const selectHomeRegimeState = createSelector(selectCatalogState, (state: CatalogState) => state.homeRegime);
export const selectHomeUsesState = createSelector(selectCatalogState, (state: CatalogState) => state.homeUses);
export const selectHomeUseState = createSelector(selectCatalogState, (state: CatalogState) => state.homeUse);
export const selectFinancialEntityNamesState = createSelector(
  selectCatalogState,
  (state: CatalogState) => state.financialEntityNames
);
export const selectFinancialEntityNameState = createSelector(
  selectCatalogState,
  (state: CatalogState) => state.financialEntityName
);
